import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { IAlertDetailsDto, IAlertingApi, IGetAlertsParams } from '@/api/alerting/alerting.types';
import {
  IAlertDto,
  IAlertNotificationSettingDto,
  IAlertUpdateRecordDto,
  ISocialContextUpdateDto,
  IWatchlistScreeningHitDto,
} from '@/types/alert';

export class AlertingApi implements IAlertingApi {
  constructor(private readonly httpClient: IHttpClient) {}

  getAlerts(params?: IGetAlertsParams) {
    return this.httpClient.get<IAlertDto[]>(ApiEndpoints.ALERTS, { params });
  }

  markAlertAsRead(alertId: string) {
    return this.httpClient.patch<void, void>(`${ApiEndpoints.ALERTS}${alertId}/read/`, undefined);
  }

  getAlertUpdates(alertId: string) {
    return this.httpClient.get<IAlertUpdateRecordDto[]>(
      `${ApiEndpoints.ALERTS}${alertId}/updates/`,
    );
  }

  getAlertDetails(alertId: string) {
    return this.httpClient.get<IAlertDetailsDto>(`${ApiEndpoints.ALERTS}${alertId}/details/`);
  }

  getAlertSocial(alertId: string) {
    return this.httpClient.get<ISocialContextUpdateDto[]>(
      `${ApiEndpoints.ALERTS}${alertId}/social/`,
    );
  }

  getAlertWatchlist(alertId: string) {
    return this.httpClient.get<IWatchlistScreeningHitDto[]>(
      `${ApiEndpoints.ALERTS}${alertId}/watchlist/`,
    );
  }

  getNotificationSettings() {
    return this.httpClient.get<IAlertNotificationSettingDto[]>(ApiEndpoints.ALERTING_SETTINGS);
  }

  updateNotificationSetting(entityId: string, notificationsEnabled: boolean) {
    return this.httpClient.patch<{ notificationsEnabled: boolean }, void>(
      `${ApiEndpoints.ALERTING_SETTINGS}${entityId}/`,
      { notificationsEnabled },
    );
  }
}
